// extracted by mini-css-extract-plugin
export default {"root":"FoldersList_root__28Fzp","all":"FoldersList_all__h65Am","list":"FoldersList_list__wwDch","itemName":"FoldersList_itemName__UyPLI","subItems":"FoldersList_subItems__tWGTK"};